import { cardAnatomy as parts } from '@chakra-ui/anatomy';
import {
  createMultiStyleConfigHelpers,
  cssVar,
} from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(parts.keys);

const $borderColor = cssVar('card-border-color');
const $radius = cssVar('card-radius');

const baseStyle = definePartsStyle({
  container: {
    borderRadius: $radius.reference,
    borderColor: $borderColor.reference,
  },
});

const sizes = {
  md: definePartsStyle({
    container: {
      [$radius.variable]: 'radii.lg',
    },
  }),
};

const variants = {
  outline: definePartsStyle({
    container: {
      [$borderColor.variable]: 'colors.gray.50',
    },
  }),
};

export const cardTheme = defineMultiStyleConfig({
  variants,
  baseStyle,
  sizes,
  defaultProps: {
    variant: 'outline',
    size: 'md',
  },
});
